/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function Model3dAnimationFromJSON(json) {
    return Model3dAnimationFromJSONTyped(json, false);
}
export function Model3dAnimationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'autoStart': !exists(json, 'auto_start') ? undefined : json['auto_start'],
        'animationIndex': !exists(json, 'animation_index') ? undefined : json['animation_index'],
        'runCount': !exists(json, 'run_count') ? undefined : json['run_count'],
        'delayMs': !exists(json, 'delay_ms') ? undefined : json['delay_ms'],
        'durationMs': !exists(json, 'duration_ms') ? undefined : json['duration_ms'],
    };
}
export function Model3dAnimationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'auto_start': value.autoStart,
        'animation_index': value.animationIndex,
        'run_count': value.runCount,
        'delay_ms': value.delayMs,
        'duration_ms': value.durationMs,
    };
}
//# sourceMappingURL=Model3dAnimation.js.map